import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { loginActions } from '../../actions/user/loginActions.js';
import Logo from '../common/logo.js';


function Login(props) {
    /**local email input state */
    const [email, setEmail] = useState({
        valid: true,
        value: ''
    });
    /**local password state */
    const [password, setPassword] = useState({
        valid: true,
        value: ''
    });
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email.value || !password.value) {
            setError('Please fill in all fields.');
            return;
        }
        setError('');
        // Call the onLogin function or handle login logic here
        props.login(email.value, password.value);
    };

    return (<>
        {props.authorized ? <>{props.location.state == null ? <Redirect to='/profile/account' /> :
            <Redirect to={{ pathname: props.location.state.from.pathname, search: props.location.state.from.search, state: { from: props.location.state } }} />}</>
            : <></>}
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className="w-100">
                <Col md={{ span: 6, offset: 3 }}>
                    <div className="p-4 border rounded-5 shadow-sm bg-white">
                        <div className='text-center mb-4'style={{fontSize: '40px'}}>
                            <Logo/>
                        </div>
                        
                        <h2 className="text-center mb-4">Login</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {props.loginError && <Alert variant="danger">Invalid Credentials</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formEmail" className="mb-3">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    value={email.value}
                                    onChange={(e) => setEmail({ ...email, value: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formPassword" className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Password"
                                    value={password.value}
                                    onChange={(e) => setPassword({ ...password, value: e.target.value })}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" className="w-100">
                                Login
                            </Button>
                        </Form>
                        <div className="text-center mt-3">
                            <Link to={'signup'}>Don't have an account? Sign up</Link>
                        </div>
                        <div className="text-center mt-2">
                            <Link to={'forgot'}>Forgot your password?</Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </>
    );
}


const mapStateToProps = (state) => {
    return {
        isFetching: state.users.user.login.isFetching,
        authorized: state.users.user.authorized,
        loginError: state.users.user.login.error
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (email, pass) => dispatch(loginActions.login(email, pass))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);